var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRestartIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "33pt",
    height: "33pt",
    viewBox: "0 0 33 33",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    enableBackground: "new"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer-1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("clipPath", {
    id: "cp0"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,0,33)",
    d: "M 0 33 L 33 33 L 33 0 L 0 0 Z "
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cp0)"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,12.8579,.16109848)",
    d: "M 0 0 L -12.567 -2.514 L -8.758 -6.323 C -10.967 -9.077 -12.332 -12.533 -12.332 -16.338 C -12.332 -25.229 -5.125 -32.439 3.77 -32.439 C 12.666 -32.439 19.873 -25.229 19.873 -16.338 C 19.873 -9.671 15.827 -3.937 10.054 -1.492 L 10.054 -5.38 C 13.858 -7.565 16.417 -11.64 16.417 -16.338 C 16.417 -23.328 10.76 -28.983 3.77 -28.983 C -3.221 -28.983 -8.876 -23.328 -8.876 -16.338 C -8.876 -13.48 -7.923 -10.874 -6.323 -8.758 L -2.514 -12.567 Z "
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRestartIcon);
export default __webpack_public_path__ + "static/media/restartIcon.f941b22e94e1413ae4d7666e636c18cb.svg";
export { ForwardRef as ReactComponent };